module.exports = __webpack_public_path__ + "static/media/default_1.54f45a63.png";